import {
  GraphQLID,
  GraphQLString,
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLInt
} from 'graphql'

export interface SessionMetadataField {
  readonly id: string | 'dissociated'
  readonly displayLabel: string
  readonly agentLabel: string
  readonly count: number
}

export const sessionMetadataFieldType = new GraphQLObjectType({
  name: 'SessionMetadataField',
  description: 'A single session metadata field',
  fields: () => ({
    id: {
      description: 'The unique ID for the field',
      type: new GraphQLNonNull(GraphQLID)
    },
    displayLabel: {
      description: 'Field label for display',
      type: new GraphQLNonNull(GraphQLString)
    },
    agentLabel: {
      description: 'Field label for agent',
      type: new GraphQLNonNull(GraphQLString)
    },
    count: {
      description: 'Field count',
      type: new GraphQLNonNull(GraphQLInt)
    }
  })
})
